module.exports = __webpack_public_path__ + "img/img46.c6e07677.svg";